<div class="pay-rates">
  <ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="vm.groups.length; else noResultsFound">
      <ng-container *ngFor="let group of vm.groups">
        <ui-simple-expand variant="transparent">
          <ng-container expand-title>
            <div>{{ group.name }}</div>
          </ng-container>
          <ng-container expand-content>
            <ng-container
              *ngIf="
                group.sections && group.sections.length;
                else noResultsFound
              "
            >
              <div
                *ngFor="let payRateItem of group.sections"
                class="pay-rates__container"
              >
                <div class="pay-rates__content">
                  <div class="pay-rates__content__title">
                    {{ payRateItem.name ?? 'No title given' }}
                  </div>
                  <div class="pay-rates__content__wages">
                    {{
                      payRateItem.minSectionRate
                        | currency: vm.currencyCode : 'symbol' : '1.2'
                    }}
                    -
                    {{
                      payRateItem.maxSectionRate
                        | currency: vm.currencyCode : 'symbol' : '1.2'
                    }}
                    per hour
                  </div>
                </div>
                <div class="pay-rates__content__table">
                  <div
                    class="pay-rates__content__table__row pay-rates__content__table__header"
                  >
                    <div>Shift</div>
                    <div>Total hourly</div>
                    <div>Excl. holiday</div>
                    <div>Holiday</div>
                  </div>
                  <div
                    *ngFor="let rate of payRateItem.rates"
                    class="pay-rates__content__table__row"
                  >
                    <div class="description">
                      {{ rate.type ?? 'No rate title given' }}
                      {{ rate.workingHours ?? 'No working hours given' }}
                    </div>
                    <div class="cell">
                      <div class="timeframe">Total hourly</div>
                      <div class="wage">
                        {{
                          rate.hourlyPay
                            | currency: vm.currencyCode : 'symbol' : '1.2'
                        }}
                      </div>
                    </div>
                    <div class="cell">
                      <div class="timeframe">Excl. holiday</div>
                      <div class="wage">
                        {{
                          rate.excludingHolidayPay
                            | currency: vm.currencyCode : 'symbol' : '1.2'
                        }}
                      </div>
                    </div>
                    <div class="cell">
                      <div class="timeframe">Holiday</div>
                      <div class="wage">
                        {{
                          rate.holidayPay
                            | currency: vm.currencyCode : 'symbol' : '1.2'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ui-simple-expand>
      </ng-container>
    </ng-container>

    <div class="pay-rates__content__links">
      <div
        *ngIf="vm.payRatesUrl as payRatesUrl"
        class="pay-rates__content__links__link"
      >
        <a [href]="payRatesUrl" target="_blank">View All Pay Rates</a>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noResultsFound>
  <div class="pay-rates__no-rates-found">No Rates Found</div>
</ng-template>
